window.Reports = {
    init: function(){

        DateRangePicker.init('#prevSalesForm');

        var options = {

            data : {
                action : "updateSalespreview"
            },
            success:function(data){
                Reports.recordFormCallback(data);
            },
            dataType:"json"
        };

        MyForm.prepare("prevSalesForm", "prospection_salespreview", options, false, false);
        MyFacture.initEvent();

        $('#prevSalesForm').submit();
        MyFacture.startWait();
    },

    recordFormCallback: function(data){
        $('#reports .alert').hide();
        var formIsOk = MyForm.processJson(data, "prevSalesForm");
        if(formIsOk) {
            MyFacture.stopWait();
            $('#reports .stats-result').html(data.prevsalesreportarray);
            Reports.initTips();
            $('.reports__container__steps').hide();
            $('.reports__container__steps').animate({width:'toggle'},1500);
        } else {
            MyFacture.stopWait();
            var errorMsg = data.form.msg;
            if(errorMsg !== ''){
                $('#reports .alert').html(errorMsg).show();
            }
        }
    },

    initTips : function (){
        $("[tip_type=stepInfos]").each(function () {
            var relatedId = $(this).attr('tip_relid');
            var funnelid = $(this).attr('tip_funnelid');
            var name = $(this).attr('tip_name');
            var pond = $(this).attr('tip_pond');
            var total = $(this).attr('tip_total');
            var nbOpp = $(this).attr('tip_nbOpp');
            var filters = $(this).attr('tip_filters');

            $(this).qtip({
                style: {
                    classes: 'qtip-custom qtip-rich',
                    def: false,
                    tip: {
                        corner: false
                    }
                },
                position: {
                    viewport: true,
                    my: 'top center',
                    at: 'middle'
                },
                show: {
                    event: 'mouseover'
                },
                hide: {
                    event: 'mouseout',
                    fixed: true,
                    delay: 100
                },
                content: {
                    text: MyWindow.getLoader(),

                    ajax: {
                        type: 'GET',
                        url: './?_f=prospection_salespreview',
                        data: {
                            action: 'popStepInfos',
                            stepid: relatedId,
                            funnelid: funnelid,
                            name: name,
                            pond: pond,
                            total: total,
                            nbOpp: nbOpp,
                            filters: filters
                        },
                        once: true
                    }
                }
            });
        });
    },
};


window.prospectionStat = {

    init: function(type, arrayOrGraph){
        var statType = type != undefined ? type : 'opportunity';
        var action = 'getStats';
        $('#prospectionStatsForm #stats_elemType').val(statType);

        switch (statType){
            case 'opportunity':
                $('#prospectionlabelTitle').html(Loc.g('Rapport de prospection'));
                $('#statsprospection .sourceFilter').hide();
                $('#statsprospection .oppFilter').show();
                if(arrayOrGraph === 'graph'){
                    var startCreated 	= $('#stats_dateStartCreated').val();
                    var endCreated 		= $('#stats_dateEndCreated').val();
                    var startUpdated 	= $('#stats_dateStartUpdated').val();
                    var endUpdated 		= $('#stats_dateEndUpdated').val();
                    if(startCreated !== '' && endCreated !== '' && startUpdated !== '' && endUpdated !== ''){
                        var options = {
                            type        : "warning",
                            resizable   : false,
                            noclose     : true,
                            title       : Loc.g("Attention"),
                            buttons     : [
                                { text : Loc.g("OK"),
                                    click : function(){
                                        $(this).dialog("close");
                                    }
                                }
                            ]
                        };
                        MyWindow.alert(Loc.g('Lorsque les 2 intervalles sont renseignés (date de création et date de dernière mise à jour), le système prendra en compte seulement l‘intervalle "Date de dernière mise à jour".'), options);
                    }
                    action = 'getStatsGraph';
                }

                break;
            case 'sources':
                $('#prospectionlabelTitle').html(Loc.g('Rapport de sources d‘opportunité'));
                $('#statsprospection .oppFilter').hide();
                $('#statsprospection .sourceFilter').show();
                action = 'getStatsSources';
                if(arrayOrGraph === 'graph'){
                    var startCreated 	= $('#stats_dateStartCreated').val();
                    var endCreated 		= $('#stats_dateEndCreated').val();
                    var startUpdated 	= $('#stats_dateStartUpdated').val();
                    var endUpdated 		= $('#stats_dateEndUpdated').val();
                    if(startCreated !== '' && endCreated !== '' && startUpdated !== '' && endUpdated !== ''){
                        var options = {
                            type        : "warning",
                            resizable   : false,
                            noclose     : true,
                            title       : Loc.g("Attention"),
                            buttons     : [
                                { text : Loc.g("OK"),
                                    click : function(){
                                        $(this).dialog("close");
                                    }
                                }
                            ]
                        };
                        MyWindow.alert(Loc.g('Lorsque les 2 intervalles sont renseignés (date de création et date de dernière mise à jour), le système prendra en compte seulement l‘intervalle "Date de dernière mise à jour".'), options);
                    }
                    action = 'getStatsSourcesGraph';
                }
                break;
            case 'activity':
                $('#prospectionlabelTitle').html(Loc.g('Rapport d‘activité'));
                $('#statsprospection .oppFilter').hide();
                $('#statsprospection .sourceFilter').hide();
                $('#statsprospection .activityFilter').show();
                action = 'getStatsActivity';
                break;
        }
        var options = {
            success:function(data){
                prospectionStat.recordFormCallback(data);
                if(action === 'getStatsSources'){
                    prospectionStat.initGraphs();
                    Utils.sortDiv($('containerResult'), '.containerStaff', 'desc', 'catopp')
                } else if (action ==='getStatsSourcesGraph' || action ==='getStatsGraph'){
                    var startCreated 	= $('#stats_dateStartCreated').val();
                    var endCreated 		= $('#stats_dateEndCreated').val();
                    var startUpdated 	= $('#stats_dateStartUpdated').val();
                    var endUpdated 		= $('#stats_dateEndUpdated').val();
                    if(startCreated !== '' && endCreated !== '' && startUpdated !== '' && endUpdated !== '') {
                        var options = {
                            type: "warning",
                            resizable: false,
                            noclose: true,
                            title: Loc.g("Attention"),
                            buttons: [
                                {
                                    text: Loc.g("OK"),
                                    click: function () {
                                        $(this).dialog("close");
                                    }
                                }
                            ]
                        };
                        MyWindow.alert(Loc.g('Lorsque les 2 intervalles sont renseignés (date de création et date de dernière mise à jour), le système prendra en compte seulement l‘intervalle "Date de dernière mise à jour".'), options);
                    }
                    prospectionStat.initGraphs();
                }
            },
            dataType:"json"};
        MyForm.prepare("prospectionStatsForm", "prospection_statsprospection&action="+action, options, false, false);
        MyFacture.initEvent();
        $('#statsprospection #submitStat').submit();
        MyFacture.startWait();
    },

    initGraphs: function(){

        $('#statsprospection div[e_autograph]').each(function(){

            var seriesName 		= $(this).attr('graph_seriesName');
            var graphType 		= $(this).attr('graph_type');

            var datas 			= {};
            if ($(this).attr('graph_data') !== undefined){
                datas = $.parseJSON($(this).attr('graph_data'));
            }

            var currencySymbol 	= $(this).attr('graph_currencySymbol') == undefined ? '' :  $(this).attr('graph_currencySymbol');

            var datasDrilldown 	=  {};
            if($(this).attr('graph_data_drilldown') !== undefined){
                datasDrilldown 	= $.parseJSON($(this).attr('graph_data_drilldown'));
            }

            var labelTooltip 	= $(this).attr('graph_labelTooltip');

            if(graphType === 'pie'){


                $(this).highcharts({
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        backgroundColor: "transparent"
                    },
                    title: {
                        text: $(this).attr('graph_name')+'<br/><b>'+$(this).attr('graph_subname')+'</b>'
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function() {
                            var percent = this.point.percentage.toFixed(2);
                            var tooltipFormatted =
                                '<div class="tooltipGraphHighChart">' +
                                '<div class="row">' +
                                '<div class="col span_9 ov-hidden ellipsis">' +
                                '<i class="fa '+this.point.icon+' mr-2" style="color: '+this.point.color+';"><xsl:comment/></i>' +
                                '<span class="bold uppercase" style="color: '+this.point.color+';">'+this.point.name+'</span>' +
                                '</div>' +
                                '<div class="col span_3 aright">' +
                                '<span class="tooltipGraphHighChart__row__value">'+percent+' %</span>' +
                                '</div>' +
                                '</div>' +
                                '<div class="row mt-2">' +
                                '<div class="col span_9">' +
                                '<span>'+labelTooltip+'</span>' +
                                '</div>' +
                                '<div class="col span_3 aright">' +
                                '<span class="tooltipGraphHighChart__row__value">'+this.y+' '+currencySymbol+'</span>' +
                                '</div>' +
                                '</div>' +
                                '</div>';

                            return tooltipFormatted;

                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: datasDrilldown === null ? true : false,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    legend: {
                        symbolHeight: 12,
                        symbolWidth: 12,
                        symbolRadius: 6,
                        backgroundColor: '#FFFFFF',
                        borderColor: '#FFFFFF',
                        width:540,
                        itemWidth:220,
                        itemStyle: {
                            width:210
                        },
                        x : 50
                    },
                    lang: {
                        noData: Loc.g('Aucune donnée à afficher')
                    },
                    credits: {
                        enabled: false
                    },
                    series: [{
                        name: seriesName,
                        colorByPoint: true,
                        data: datas
                    }],
                    drilldown: {
                        series: datasDrilldown
                    }
                });
            }
            else if(graphType === 'column'){

                var categories 		= {}

                if($(this).attr('graph_axisX') !== undefined){
                    $.parseJSON($(this).attr('graph_axisX'));
                }


                var axisY 			= $(this).attr('graph_axisY');
                var graphid 		= $(this).attr('id');

                var datasArray = [];
                if(datas){
                    $.each( datas, function( key, value ) {
                        datasArray.push(value);
                    });
                }

                $(this).highcharts({
                    chart: {
                        type: 'column',
                        backgroundColor: "transparent"
                    },
                    title: {
                        text: ''
                    },

                    xAxis: {
                        categories: categories
                    },

                    yAxis: {
                        allowDecimals: false,
                        min: 0,
                        title: {
                            text: axisY
                        }
                    },

                    tooltip: {
                        useHTML: true,
                        formatter: function() {
                            var percent = this.point.percentage.toFixed(2);
                            var tooltipFormatted = '';
                            if(this.series.options.icon !== undefined){
                                tooltipFormatted =
                                    '<div class="tooltipGraphHighChart">' +
                                    '<div class="row">' +
                                    '<div class="col span_9 ov-hidden ellipsis">' +
                                    '<i class="fa '+this.series.options.icon+' mr-2" style="color: '+this.point.color+';"><xsl:comment/></i>' +
                                    '<span class="bold uppercase" style="color: '+this.point.color+';>'+this.series.name+'</span>' +
                                    '</div>' +
                                    '<div class="col span_3 aright">' +
                                    '<span class="tooltipGraphHighChart__row__value">'+percent+' %</span>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="row mt-2">' +
                                    '<div class="col span_9">' +
                                    '<span>'+labelTooltip+'</span>' +
                                    '</div>' +
                                    '<div class="col span_3 aright">' +
                                    '<span class="tooltipGraphHighChart__row__value">'+this.y+' '+currencySymbol+'</span>' +
                                    '</div>' +
                                    '</div>' +
                                    '</div>';
                            } else{
                                var staffsPeriod = this.series.options.staffs[this.point.index];
                                if(graphid === 'stats_tasksByCategory' || graphid === 'stats_eventsByCategory'){
                                    tooltipFormatted =
                                        '<div class="tooltipGraphHighChart">' +
                                        '<div class="row">' +
                                        '<div class="col span_9 ov-hidden ellipsis">';
                                    if(graphid === 'stats_tasksByCategory'){
                                        tooltipFormatted += '<i class="fa fa-check-circle-o mr-2" style="color: '+this.point.color+';"></i>';
                                    } else if(graphid === 'stats_eventsByCategory'){
                                        tooltipFormatted += '<i class="fa fa-calendar mr-2" style="color: '+this.point.color+';"></i>';
                                    }
                                    tooltipFormatted +=
                                        '<span class="bold uppercase">'+this.series.name+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+percent+' %</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-3">' +
                                        '<div class="col span_9">' +
                                        '<span class="semibold" style="color: rgba(53,89,110,0.5);">'+labelTooltip+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.y+'</span>' +
                                        '</div>' +
                                        '</div>';
                                } else{
                                    tooltipFormatted =
                                        '<div class="tooltipGraphHighChart">' +
                                        '<div class="row">' +
                                        '<div class="col span_9">' +
                                        '<span class="bold uppercase" style="color: '+this.point.color+';">'+this.series.name+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.y+'</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-3">' +
                                        '<div class="col span_9">' +
                                        '<span class="semibold" style="color: rgba(53,89,110,0.5);">'+Loc.g("Total Devisé HT")+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.series.options.devise[this.point.index]+'</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-2">' +
                                        '<div class="col span_9">' +
                                        '<span class="semibold" style="color: rgba(53,89,110,0.5);">'+Loc.g("Total Facturé HT")+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.series.options.facture[this.point.index]+'</span>' +
                                        '</div>' +
                                        '</div>';
                                }
                                var isAdmin = $('#stats_isAdmin').val();
                                if(isAdmin === 'Y'){
                                    tooltipFormatted +=
                                        '<div class="row mt-3">' +
                                        '<div class="col span_12">' +
                                        '<hr/>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-3">' +
                                        '<div class="col span_12 semiboldd">' +
                                        Object.keys(staffsPeriod).length+ ' <span class="uppercase"Ò>'+Loc.g('collaborateur(s)')+'</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="mt-2">';

                                    if(staffsPeriod){
                                        $.each( staffsPeriod, function( key, value ) {
                                            if(value.avatar.type === 'initials'){
                                                tooltipFormatted +=
                                                    '<div class="prelative dinlineb mr-3">' +
                                                    '<span class="avatar avatar-big">' +
                                                    value.avatar.value +
                                                    '</span>' +
                                                    '<div class="tooltipGraphHighChart__notif">' +
                                                    '<div class="tooltipGraphHighChart__notif__value">' +
                                                    '<span>'+value.cpt+'</span>'+
                                                    '</div>' +
                                                    '</div>' +
                                                    '<div class="clear";></div>' +
                                                    '</div>';
                                            } else{
                                                tooltipFormatted +=
                                                    '<div class="prelative dinlineb mr-3">' +
                                                    '<span class="avatar avatar-big avatar-picture">' +
                                                    '<img src="'+value.avatar.value+'" >' +
                                                    '</span>' +
                                                    '<div class="tooltipGraphHighChart__notif">' +
                                                    '<div class="tooltipGraphHighChart__notif__value">' +
                                                    '<span>'+value.cpt+'</span>'+
                                                    '</div>' +
                                                    '</div>' +
                                                    '<div class="clear";></div>' +
                                                    '</div>';
                                            }
                                        });
                                    }
                                    tooltipFormatted +=
                                        '</div>';
                                }
                                tooltipFormatted +=
                                    '</div>';

                            }
                            return tooltipFormatted;
                        },
                    },

                    plotOptions: {
                        column: {
                            stacking: 'normal'
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        width:960,
                        itemWidth: 310,
                        itemStyle: {
                            width:300
                        }
                    },
                    lang: {
                        noData: Loc.g('Aucune donnée à afficher')
                    },
                    series: datasArray
                });
            }
        });

    },

    updateStatsPeriod : function(filters, elem){
        var blocStat = elem.parent().parent().parent().find('.tt_oneGraph');

        elem.parent().find('a').removeClass('graphTitle__period__a--active');
        elem.addClass('graphTitle__period__a--active');

        var datas = {
            start: 			blocStat.attr('graph_start'),
            end: 			blocStat.attr('graph_end'),
            staffGroup: 	blocStat.attr('graph_staffGroup'),
            typeGraph: 		blocStat.attr('graph_typeGraph'),
            filterUsed: 	blocStat.attr('graph_filterUsed'),
            filters:		filters,
            idGraph : 		blocStat.attr('id'),
            funnel : 		blocStat.attr('graph_funnel'),
            category : 		blocStat.attr('graph_category'),
            oppStatus : 	blocStat.attr('graph_oppStatus'),
        };
        MyFacture.startWait();
        var file = "prospection_statsprospection";
        if(datas.idGraph === 'stats_tasksByCategory' || datas.idGraph === 'stats_eventsByCategory'){
            file = "reports";
        }
        MyFacture.post(file+"&action=updateStatGrah", datas, function(data){
            if(data.success === 'ok'){
                MyFacture.stopWait();

                if(data.axisX !== undefined){
                    var categories = $.parseJSON(data.axisX);
                }

                if(data.dataGraph !== undefined){
                    var datas = $.parseJSON(data.dataGraph);
                }

                var axisY 			= blocStat.attr('graph_axisY');
                var currencySymbol 	= blocStat.attr('graph_currencySymbol') == undefined ? '' :  blocStat.attr('graph_currencySymbol');
                var labelTooltip 	= blocStat.attr('graph_labelTooltip');
                var graphid			= blocStat.attr('id');

                var datasArray = [];
                if(datas){
                    $.each( datas, function( key, value ) {
                        datasArray.push(value);
                    });
                }

                blocStat.highcharts({
                    chart: {
                        type: 'column',
                        backgroundColor: "transparent",
                    },
                    title: {
                        text: '',
                    },

                    xAxis: {
                        categories: categories
                    },

                    yAxis: {
                        allowDecimals: false,
                        min: 0,
                        title: {
                            text: axisY
                        }
                    },

                    tooltip: {
                        useHTML: true,
                        formatter: function() {
                            var percent = this.point.percentage.toFixed(2);
                            var tooltipFormatted = '';
                            if(this.series.options.icon !== undefined){
                                tooltipFormatted =
                                    '<div class="tooltipGraphHighChart">' +
                                    '<div class="row">' +
                                    '<div class="col span_9 ov-hidden ellipsis">' +
                                    '<i class="fa '+this.series.options.icon+' mr-2" style="color: '+this.point.color+';"><xsl:comment/></i>' +
                                    '<span class="bold uppercase" style="color: '+this.point.color+';>'+this.series.name+'</span>' +
                                    '</div>' +
                                    '<div class="col span_3 aright">' +
                                    '<span class="tooltipGraphHighChart__row__value">'+percent+' %</span>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="row mt-2">' +
                                    '<div class="col span_9">' +
                                    '<span>'+labelTooltip+'</span>' +
                                    '</div>' +
                                    '<div class="col span_3 aright">' +
                                    '<span class="tooltipGraphHighChart__row__value">'+this.y+' '+currencySymbol+'</span>' +
                                    '</div>' +
                                    '</div>' +
                                    '</div>';
                            } else{
                                var staffsPeriod = this.series.options.staffs[this.point.index];
                                if(graphid === 'stats_tasksByCategory' || graphid === 'stats_eventsByCategory'){
                                    tooltipFormatted =
                                        '<div class="tooltipGraphHighChart">' +
                                        '<div class="row">' +
                                        '<div class="col span_9 ov-hidden ellipsis">';
                                    if(graphid === 'stats_tasksByCategory'){
                                        tooltipFormatted += '<i class="fa fa-check-circle-o mr-2" style="color: '+this.point.color+';"></i>';
                                    } else if(graphid === 'stats_eventsByCategory'){
                                        tooltipFormatted += '<i class="fa fa-calendar mr-2" style="color: '+this.point.color+';"></i>';
                                    }
                                    tooltipFormatted +=
                                        '<span class="bold uppercase" style="color: '+this.point.color+';">'+this.series.name+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright"">' +
                                        '	<span class="tooltipGraphHighChart__row__value">'+percent+' %</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-3">' +
                                        '<div class="col span_9">' +
                                        '<span class="semibold" style="color: rgba(53,89,110,0.5);">'+labelTooltip+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.y+'</span>' +
                                        '</div>' +
                                        '</div>';
                                } else{
                                    tooltipFormatted =
                                        '<div class="tooltipGraphHighChart">' +
                                        '<div class="row">' +
                                        '<div class="col span_9 ov-hidden ellipsis">' +
                                        '<span class="bold uppercase" style="color: '+this.point.color+';">'+this.series.name+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.y+'</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-3">' +
                                        '<div class="col span_9">' +
                                        '<span class="semibold" style="color: rgba(53,89,110,0.5);">'+Loc.g("Total Devisé HT")+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.series.options.devise[this.point.index]+'</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-2">' +
                                        '<div class="col span_9">' +
                                        '<span class="semibold" style="color: rgba(53,89,110,0.5);">'+Loc.g("Total Facturé HT")+'</span>' +
                                        '</div>' +
                                        '<div class="col span_3 aright">' +
                                        '<span class="tooltipGraphHighChart__row__value">'+this.series.options.facture[this.point.index]+'</span>' +
                                        '</div>' +
                                        '</div>';
                                }
                                var isAdmin = $('#stats_isAdmin').val();
                                if(isAdmin === 'Y'){
                                    tooltipFormatted +=
                                        '<div class="row mt-2">' +
                                        '<div class="col span_12">' +
                                        '<hr/>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="row mt-2">' +
                                        '<div class="col span_12 semibold">' +
                                        Object.keys(staffsPeriod).length+ ' <span class="uppercase">'+Loc.g('collaborateur(s)')+'</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<div class="mt-2">';

                                    if(staffsPeriod){
                                        $.each( staffsPeriod, function( key, value ) {
                                            if(value.avatar.type === 'initials'){
                                                tooltipFormatted +=
                                                    '<div class="prelative dinlineb mr-3">' +
                                                    '<span class="avatar avatar-big">' +
                                                    value.avatar.value +
                                                    '</span>' +
                                                    '<div class="tooltipGraphHighChart__notif">' +
                                                    '<div class="tooltipGraphHighChart__notif__value">' +
                                                    '<span>'+value.cpt+'</span>'+
                                                    '</div>' +
                                                    '</div>' +
                                                    '<div class="clear";></div>' +
                                                    '</div>';
                                            } else{
                                                tooltipFormatted +=
                                                    '<div class="prelative dinlineb mr-3">' +
                                                    '<span class="avatar avatar-big avatar-picture">'+
                                                    '<img src="'+value.avatar.value+'">' +
                                                    '</span>' +
                                                    '<div class="tooltipGraphHighChart__notif">' +
                                                    '<div class="tooltipGraphHighChart__notif__value">' +
                                                    '<span>'+value.cpt+'</span>'+
                                                    '</div>' +
                                                    '</div>' +
                                                    '<div class="clear";></div>' +
                                                    '</div>';
                                            }
                                        });
                                    }
                                    tooltipFormatted +=
                                        '</div>';
                                }
                                tooltipFormatted +=
                                    '</div>';

                            }
                            return tooltipFormatted;
                        },
                    },

                    plotOptions: {
                        column: {
                            stacking: 'normal'
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        width:960,
                        itemWidth: 310,
                        itemStyle: {
                            width:300
                        }
                    },
                    lang: {
                        noData: Loc.g('Aucune donnée à afficher')
                    },
                    series: datasArray
                });
            } else{
                var options = {
                    type        : "error",
                    resizable   : false,
                    noclose     : true,
                    title       : Loc.g("Erreur"),
                    buttons     : [
                        { text : Loc.g("OK"),
                            click : function(){
                                $(this).dialog("close");
                            }
                        }
                    ]
                };
                MyWindow.alert(Loc.g('Erreur lors de la génération des statistiques.'), options);
            }
        }, "json");
    },

    recordFormCallback: function(data){
        $('#prospectionStatsForm .alert').hide();
        var formIsOk = MyForm.processJson(data, "prospectionStatsForm");
        if(formIsOk) {
            MyFacture.stopWait();
            $('#statsprospection .stats-result').html(data.statsprospectionarray);
            Utils.sortDiv($('containerResult'), '.containerStaff', 'desc', 'catopp')
            Qtip.init();
        } else {
            MyFacture.stopWait();
            var errorMsg = data.form.msg;
            if(errorMsg !== ''){
                $('#statsprospection .alert').html(errorMsg).show();
            }
        }
    },

    toggleStatsStaff: function(id){
        $(".stats_"+id).each(function(){
            if($(this).hasClass('hide')){
                $(this).removeClass('hide');
                $("#seeMore_"+id).html(Loc.g('Voir moins de détails'));
                $("#seeMoreFa_"+id).removeClass('icon-more');
                $("#seeMoreFa_"+id).addClass('icon-less');

            } else{
                $(this).addClass('hide');
                $("#seeMore_"+id).html(Loc.g('Voir plus de détails'));
                $("#seeMoreFa_"+id).removeClass('icon-less');
                $("#seeMoreFa_"+id).addClass('icon-more');
            }
        });
    },

    sortStat: function(){
        var attr = $('#statsprospection #selectSortStat').val();
        var datas = attr.split('_');
        Utils.sortDiv($('.containerResult'), '.containerStaff', datas[0], datas[1])
    },

    toggleStatType: function(elem){
        $('#statsprospection .itemNav__element').removeClass('itemNav__element--active');
        $('#statsprospection .itemNav').removeClass('itemNav--active');
        $(elem).addClass('itemNav__element--active');
        $(elem).closest('.itemNav').addClass('itemNav--active');
    },

    submitForm: function(){
        MyFacture.startWait();
        Listing.update('oppreport');
    },

};


window.reports = {

    init: function(type, arrayOrGraph){

        var statType 	= type != undefined ? type : 'activity';
        var action 		= 'getStatsActivity';

        if(arrayOrGraph == 'graph'){
            var action = 'getStatsActivityGraph';
        }
        var options = {
            success:function(data){
                reports.recordFormCallback(data);
                prospectionStat.initGraphs();
                Utils.sortDiv($('containerResult'), '.containerStaff', 'desc', 'nbevents')
                $('.viewStaff').hide();
            },
            dataType:"json"};
        MyForm.prepare("statsReportsForm", "reports&action="+action, options, false, false);
        MyFacture.initEvent();
        $('#statsprospection #submitStat').submit();
        MyFacture.startWait();
    },

    recordFormCallback: function(data){
        $('#statsreports .alert').hide();
        var formIsOk = MyForm.processJson(data, "statsReportsForm");
        if(formIsOk) {
            MyFacture.stopWait();
            $('#statsprospection .stats-result').html(data.reportsactivity);
            Utils.sortDiv($('containerResult'), '.containerStaff', 'desc', 'nbEvents')
            Qtip.init();
        } else {
            MyFacture.stopWait();
            var errorMsg = data.form.msg;
            if(errorMsg !== ''){
                $('#statsprospection .alert').html(errorMsg).show();
            }
        }
    },

    switchView: function(elem){
        switch(elem.val()){
            case 'category':
                $('#viewPerStaff').hide();
                $('#viewPerCategory').show();
                $('.viewStaff').hide();
                $('.viewCategory').show();
                break;
            case 'staff':
                $('#viewPerStaff').show();
                $('#viewPerCategory').hide();
                $('.viewStaff').show();
                $('.viewCategory').hide();
                break;
        }
    },
};
